const colors = {
  epLinkBlue: '#2f0086',
  epPurple: '#D4DEF7',
  duskBlue: '#2f0086',
  duskBlueShades: ['#10457a', '#10457a', '#10457a'],
  oceanBlue: '#2f0086',
  skyBlue: '#06b6ed',
  mantisGreen: '#78b75e',
  darkBlue: '#0017b3',
  darkBlueShades: ['#2d566f', '#6d8898', '#b4d0e1'],
  mediumBlue: '#2f0086',
  mediumBlueShades: ['#0086d9', '#75c9ff', '#a6ddff'],
  lightBlue: '#2ec4f3',
  lightBlueShades: ['#6ccbed', '#b9edff', '#d2f3ff'],
  darkPurple: '#403085',
  darkPurpleShades: ['#7a6faa', '#b3adcf', '#edebf4'],
  ccPurple: '#2f0086',
  ccPurpleLight: '#5200EA',
  ccActivePurple: '#4000B8',
  ccRed: '#951000',
  ccRedLight: '#C31500',
  mediumPurple: '#b880b6',
  mediumPurpleShades: ['#d1a6cf', '#ead1f1', '#f6ebf6'],
  mediumRed: '#ec4624',
  mediumRedShades: ['#f0673b', '#fbb8ab', '#ffeeea'],
  lightRed: '#f0673b',
  darkGreen: '#133e2a',
  darkGreenShades: ['#5e786a', '#a4b2ab', '#e8ecea'],
  mediumGreen: '#2d8b43',
  mediumGreenShades: ['#73af7d', '#b1d1b5', '#edf5ee'],
  gold: '#916800',
  goldShades: ['#e6b95e', '#f7e5bf', '#fcf1da'],
  yellow: '#f7cf1d',
  yellowShades: ['#ffe365', '#fff1b4', '#fff9e0'],

  black: '#000',
  epBlack: '#232425',
  darkGray: '#5c5c5c',
  mediumGray: '#aaa',
  gray: '#e5e5e5',
  lightGray: '#f5f5f5',
  white: '#ffffff',

  white85: 'rgba(255, 255, 255, 0.85)',
  mediumBlue85: 'rgba(20,116,212,0.85)',

  footerNav: '#5c5c5c',
  bannerGreen: '#d9eea5',
  bannerBlue: '#bed2e9',
  backgroundBlue: '#e9f2fb',
  goldOverDarkBackground: '#edaa00',
} as const;

export default colors;
